import { createFileRoute } from "@tanstack/react-router";

import IntakeList from "@/pages/intake/IntakeList";

export const Route = createFileRoute("/intake/")({
  component: IntakeList,
});
